<nz-badge nzStandalone [nzCount]="iconTemplate" class="bad-state"></nz-badge>
<ng-template #iconTemplate>
    <dpqa-icon iconName="cross" [iconSize]="2" />
</ng-template>
